import React from 'react'
import { makeStyles, createStyles, Menu, MenuItem, Box } from '@material-ui/core'
import { DIALING_CODES } from 'src/utils/constant'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      padding: 0,
      boxShadow: `0.5px 0 0 0 ${theme.palette.grey[100]}`,
      border: 'none',
      color: theme.palette.grey[900],
      paddingRight: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
      height: theme.spacing(1.5),
      lineHeight: `${theme.spacing(1.5)}px`,
    },
    icon: {
      display: 'none',
    },
  }),
)

const DialingCodeSelector = ({ value, onChange }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [activeDialingCode, setActiveDialingCode] = React.useState(value)
  const { t } = useTranslation()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelectDialingCode = (e, newValue) => {
    setActiveDialingCode(newValue)
    onChange?.(newValue)
    setAnchorEl(null)
  }
  return (
    <>
      <Box className={classes.root} classes={{ endIcon: classes.endIcon }} onClick={handleClick}>
        {'+' + activeDialingCode}
      </Box>
      <Menu
        id="dialing-code-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        elevation={1}
        anchorOrigin={{
          vertical: 24,
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {DIALING_CODES.map((dialingCode) => (
          <MenuItem key={dialingCode.value} onClick={(e) => handleSelectDialingCode(e, dialingCode.value)}>
            {'+' + t(dialingCode.value)}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default DialingCodeSelector
